import axios from "axios";
import { domain } from "../Links/Links";
import { getCookie } from "../../App";

export async function OrderRequest(
  receiverUsername,
  amount,
  discription,
  setRequestStatus,
  setActive,
  setOrderStatus,
  navigate,
) {
  setRequestStatus(true);
  const data = {
    receiver_username: receiverUsername,
    amount: amount,
    discription: discription,
  };

  const response = await axios.post(domain + "/order/", data, {
    withCredentials: true,
    headers: {
      "X-CSRFToken": getCookie("csrf_token"),
    },
  });

  if (response.data.ok == true) {
    setRequestStatus(false);

    setActive(false);
    setTimeout(() => {
        setOrderStatus(false);
    }, 150);

    navigate('/history');

  } else {
    setRequestStatus(false);
  }
}
